// apexcharts-mouse-fix.js
/**
 * When CSS `zoom` is applied (e.g. `html { zoom: 85% }`), getBoundingClientRect()
 * returns coordinates in the zoomed (viewport) space, while ApexCharts internally
 * works in un-zoomed CSS-pixel space.
 *
 * This fixes the tooltip positioning by recalculating the pointer position.
 */

const apexMouseFixPlugin = {
    // Store original event handlers
    originalHandlers: new WeakMap(),

    // Fix tooltip positioning
    fixTooltipPosition(chartElement, event) {
        if (!event || !event.clientX || !chartElement) return event;

        const rect = chartElement.getBoundingClientRect();
        const canvas = chartElement.querySelector('canvas') || chartElement;

        // Calculate effective zoom factor
        const zoomX = rect.width / canvas.offsetWidth;
        const zoomY = rect.height / canvas.offsetHeight;

        // Convert viewport coordinates to CSS-pixel space
        const fixedEvent = {
            ...event,
            clientX: (event.clientX - rect.left) / zoomX + rect.left,
            clientY: (event.clientY - rect.top) / zoomY + rect.top,
            offsetX: (event.clientX - rect.left) / zoomX,
            offsetY: (event.clientY - rect.top) / zoomY,
            pageX: (event.pageX - rect.left) / zoomX + rect.left,
            pageY: (event.pageY - rect.top) / zoomY + rect.top
        };

        return fixedEvent;
    },

    // Apply fix to chart instance
    apply(chart) {
        if (!chart || !chart.w || !chart.w.globals) return;

        const canvas = chart.w.globals.dom.baseEl;
        if (!canvas) return;

        // Override the tooltip position calculation
        const originalGetTooltipPosition = chart.w.globals.getTooltipPosition;

        chart.w.globals.getTooltipPosition = function(e) {
            const fixedEvent = apexMouseFixPlugin.fixTooltipPosition(canvas, e);
            return originalGetTooltipPosition ? originalGetTooltipPosition.call(this, fixedEvent) : null;
        };

        // Add mouse move listener with fixed coordinates
        const handleMouseMove = (e) => {
            const fixedEvent = apexMouseFixPlugin.fixTooltipPosition(canvas, e);
            if (chart.w.globals.mouseMove) {
                chart.w.globals.mouseMove(fixedEvent);
            }
        };

        canvas.addEventListener('mousemove', handleMouseMove);

        // Store for cleanup
        if (!canvas._mouseFixHandler) {
            canvas._mouseFixHandler = handleMouseMove;
        }
    },

    // Cleanup
    destroy(chart) {
        if (!chart || !chart.w || !chart.w.globals) return;

        const canvas = chart.w.globals.dom.baseEl;
        if (canvas && canvas._mouseFixHandler) {
            canvas.removeEventListener('mousemove', canvas._mouseFixHandler);
            delete canvas._mouseFixHandler;
        }
    }
};

export default apexMouseFixPlugin;